import { Resource } from 'json-api-hooks';

import {
  DepartmentResource,
  EventResource,
  GroupResource,
  StreetResource,
  SurveyFieldOptionResource,
  SurveyFieldResource,
  UserResource,
} from '../models';

const toString = (resource: Resource | undefined, fallback?: string): string => {
  if (!resource) {
    return fallback ?? '';
  }

  switch (resource.type) {
    case 'departments':
      return (resource as DepartmentResource).attributes.name;
    case 'events':
      return (resource as EventResource).attributes.name;
    case 'groups':
      return (resource as GroupResource).attributes.name;
    case 'streets':
      return (resource as StreetResource).attributes.inputName;
    case 'users':
      return (resource as UserResource).attributes.fullName;
    case 'survey_fields':
      return `${(resource as SurveyFieldResource).attributes.key}: ${(resource as SurveyFieldResource).attributes.label ?? (resource as SurveyFieldResource).attributes.description ?? ''}`;
    case 'survey_field_options':
      return (resource as SurveyFieldOptionResource).attributes.label;
    default:
      return fallback ?? `${resource.type} ${resource.id}`;
  }
};

export default toString;
